import { NavLink } from 'react-router-dom'
import { routersPath } from '@router/routes-path'
import React from 'react'
import { ITabs } from '@components/SideBar/Tabs/adminTabs'
import { IconChartBar, IconClipboardCheck, IconDollarSendSquare } from '@utils/icons'

export const crmTabs = ({ crmId, crmName }: { crmId: string; crmName: string }): ITabs[] => [
  {
    title: (
      <NavLink to={routersPath.CRM_STAT} state={{ crmId, crmName }}>
        <IconChartBar width='22' height='22' fill='var(--color-main)' />
        Статистика
      </NavLink>
    ),
    pages: [routersPath.CRM_STAT],
  },
  {
    title: (
      <NavLink to={routersPath.CRM_PAYMENTS} state={{ crmId, crmName }}>
        <IconDollarSendSquare width='22' height='22' fill='var(--color-main)' />
        Оплаты
      </NavLink>
    ),
    pages: [routersPath.CRM_PAYMENTS],
  },
  {
    title: (
      <NavLink to={routersPath.CRM_SUBSCRIPTIONS} state={{ crmId, crmName }}>
        <IconClipboardCheck width='22' height='22' fill='var(--color-main)' />
        Подписка
      </NavLink>
    ),
    pages: [routersPath.CRM_SUBSCRIPTIONS],
  },
]
